<div class="asg">

  <header class="asg__header">
    <div>
      <h1 class="asg__title">
        <i class="fa-solid fa-clipboard-list asg__title-icon"></i>
        {{ 'ASSIGNMENTS.TITLE' | translate }}
      </h1>
      <p class="asg__subtitle">{{ 'ASSIGNMENTS.SUBTITLE' | translate }}</p>
    </div>
    <div class="asg__header-right">
      <span class="asg__count">
        {{ 'ASSIGNMENTS.COUNT' | translate:{ count: filtered().length } }}
      </span>
      <button class="asg__btn asg__btn--create" type="button" (click)="openCreate()">
        <i class="fa-solid fa-plus"></i>
        {{ 'ASSIGNMENTS.CREATE.BTN' | translate }}
      </button>
    </div>
  </header>

  <!-- Status tabs -->
  <nav class="asg__tabs" aria-label="Status">
    <button class="asg__tab" type="button"
            [class.is-active]="activeTab() === 'all'"
            (click)="setTab('all')">
      {{ 'ASSIGNMENTS.TABS.ALL' | translate }}
      <span class="asg__tab-count">{{ counts().all }}</span>
    </button>
    <button class="asg__tab" type="button"
            [class.is-active]="activeTab() === 'draft'"
            (click)="setTab('draft')">
      <i class="fa-solid fa-pen-ruler"></i>
      {{ 'ASSIGNMENTS.STATUS.DRAFT' | translate }}
      <span class="asg__tab-count">{{ counts().draft }}</span>
    </button>
    <button class="asg__tab" type="button"
            [class.is-active]="activeTab() === 'active'"
            (click)="setTab('active')">
      <i class="fa-solid fa-circle-play"></i>
      {{ 'ASSIGNMENTS.STATUS.ACTIVE' | translate }}
      <span class="asg__tab-count">{{ counts().active }}</span>
    </button>
    <button class="asg__tab" type="button"
            [class.is-active]="activeTab() === 'closed'"
            (click)="setTab('closed')">
      <i class="fa-solid fa-circle-stop"></i>
      {{ 'ASSIGNMENTS.STATUS.CLOSED' | translate }}
      <span class="asg__tab-count">{{ counts().closed }}</span>
    </button>
  </nav>

  <!-- Search -->
  <div class="asg__search">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input type="search"
           [value]="query()"
           (input)="onQueryInput($any($event.target).value)"
           [placeholder]="'ASSIGNMENTS.SEARCH_PLACEHOLDER' | translate">
  </div>

  <!-- Loading skeleton -->
  <div *ngIf="loading()" class="asg__skeleton">
    <div class="asg__skel-row" *ngFor="let _ of [1,2,3]"></div>
  </div>

  <ng-container *ngIf="!loading()">

    <!-- Erreur de chargement : jamais de données de substitution -->
    <app-error-state *ngIf="errored()"
                     titleKey="ASSIGNMENTS.ERROR_TITLE"
                     messageKey="ASSIGNMENTS.ERROR_DESC"
                     (retry)="reload()"></app-error-state>

    <ng-container *ngIf="!errored()">
    <!-- List -->
    <ul class="asg__list" *ngIf="filtered().length > 0; else emptyTpl">
      <li *ngFor="let a of filtered()" class="asg__row">
        <!-- Status badge -->
        <span class="asg__status"
              [style.color]="statusVisual(a.status).color"
              [style.background]="statusVisual(a.status).bg">
          <i [class]="statusVisual(a.status).icon"></i>
          {{ statusVisual(a.status).label | translate }}
        </span>

        <!-- Main -->
        <div class="asg__main">
          <h3 class="asg__name">{{ a.testTitle }}</h3>
          <ul class="asg__meta">
            <li *ngIf="a.testMode">
              <i class="fa-solid fa-flag"></i>
              {{ a.testMode }}
            </li>
            <li>
              <i [class]="targetIcon(a)"></i>
              {{ targetLabel(a) }}
            </li>
            <li *ngIf="a.subjectName && a.targetType !== 'subject'">
              <i class="fa-solid fa-book"></i>
              {{ a.subjectName }}
            </li>
            <li *ngIf="a.dueDate">
              <i class="fa-solid fa-calendar-day"></i>
              {{ a.dueDate | localizedDate: 'mediumDate' }}
            </li>
          </ul>
          <p class="asg__instr" *ngIf="a.instructions">{{ a.instructions }}</p>
        </div>

        <!-- Actions -->
        <div class="asg__actions">
          <button *ngIf="a.status === 'draft'"
                  class="asg__btn asg__btn--primary"
                  type="button"
                  (click)="activate(a)">
            <i class="fa-solid fa-circle-play"></i>
            {{ 'ASSIGNMENTS.ACTIONS.ACTIVATE' | translate }}
          </button>
          <button *ngIf="a.status === 'active'"
                  class="asg__btn asg__btn--warn"
                  type="button"
                  (click)="close(a)">
            <i class="fa-solid fa-circle-stop"></i>
            {{ 'ASSIGNMENTS.ACTIONS.CLOSE' | translate }}
          </button>
          <button *ngIf="a.status !== 'closed'"
                  class="asg__btn asg__btn--ghost"
                  type="button"
                  (click)="openEdit(a)"
                  [title]="'ASSIGNMENTS.ACTIONS.EDIT' | translate">
            <i class="fa-solid fa-pen"></i>
          </button>
          <button class="asg__btn asg__btn--ghost asg__btn--danger"
                  type="button"
                  (click)="remove(a)"
                  [title]="'ASSIGNMENTS.ACTIONS.DELETE' | translate">
            <i class="fa-solid fa-trash-can"></i>
          </button>
        </div>
      </li>
    </ul>

    <ng-template #emptyTpl>
      <div class="asg__empty">
        <div class="asg__empty-icon"><i class="fa-solid fa-clipboard-question"></i></div>
        <h3>{{ 'ASSIGNMENTS.EMPTY_TITLE' | translate }}</h3>
        <p>{{ 'ASSIGNMENTS.EMPTY_DESC' | translate }}</p>
        <button class="asg__btn asg__btn--create asg__empty-cta" type="button" (click)="openCreate()">
          <i class="fa-solid fa-plus"></i>
          {{ 'ASSIGNMENTS.CREATE.BTN' | translate }}
        </button>
      </div>
    </ng-template>
    </ng-container>
  </ng-container>

</div>

<!-- ══════════════════════════════════════════════════════════
     CREATE WIZARD MODAL
════════════════════════════════════════════════════════════ -->
<div class="asg-modal-backdrop" *ngIf="createOpen()" (click)="closeCreate()"></div>
<div class="asg-modal asg-modal--wide" role="dialog" aria-modal="true" *ngIf="createOpen()">

  <!-- Header with breadcrumb steps -->
  <div class="asg-modal__header">
    <div class="asg-wizard-steps">
      <span class="asg-wizard-step" [class.is-active]="createStep() === 1" [class.is-done]="createStep() > 1">
        <span class="asg-wizard-step__dot">
          <i class="fa-solid fa-check" *ngIf="createStep() > 1; else dot1"></i>
          <ng-template #dot1>1</ng-template>
        </span>
        {{ 'ASSIGNMENTS.CREATE.STEP1_LABEL' | translate }}
      </span>
      <span class="asg-wizard-step__sep"><i class="fa-solid fa-chevron-right"></i></span>
      <span class="asg-wizard-step" [class.is-active]="createStep() === 2">
        <span class="asg-wizard-step__dot">2</span>
        {{ 'ASSIGNMENTS.CREATE.STEP2_LABEL' | translate }}
      </span>
    </div>
    <button class="asg-modal__close" type="button" (click)="closeCreate()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- ── STEP 1 : pick a test ───────────────────────────────── -->
  <ng-container *ngIf="createStep() === 1">
    <div class="asg-modal__step-header">
      <h2 class="asg-modal__title">
        <i class="fa-solid fa-magnifying-glass-plus"></i>
        {{ 'ASSIGNMENTS.CREATE.STEP1_TITLE' | translate }}
      </h2>
      <p class="asg-modal__step-sub">{{ 'ASSIGNMENTS.CREATE.STEP1_SUB' | translate }}</p>
    </div>

    <!-- Mode tabs -->
    <nav class="asg-picker__tabs">
      <button class="asg-picker__tab" type="button" [class.is-active]="testModeFilter() === 'all'" (click)="onTestModeFilter('all')">
        {{ 'ASSIGNMENTS.TABS.ALL' | translate }}
        <span class="asg-picker__tab-count">{{ availableTests().length }}</span>
      </button>
      <button class="asg-picker__tab" type="button" [class.is-active]="testModeFilter() === 'exam'" (click)="onTestModeFilter('exam')">
        <i class="fa-solid fa-graduation-cap"></i>
        {{ 'ASSIGNMENTS.MODE.EXAM' | translate }}
      </button>
      <button class="asg-picker__tab" type="button" [class.is-active]="testModeFilter() === 'practice'" (click)="onTestModeFilter('practice')">
        <i class="fa-solid fa-dumbbell"></i>
        {{ 'ASSIGNMENTS.MODE.PRACTICE' | translate }}
      </button>
      <button class="asg-picker__tab" type="button" [class.is-active]="testModeFilter() === 'evaluation'" (click)="onTestModeFilter('evaluation')">
        <i class="fa-solid fa-chart-simple"></i>
        {{ 'ASSIGNMENTS.MODE.EVALUATION' | translate }}
      </button>
    </nav>

    <!-- Search -->
    <div class="asg-picker__search">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input type="search"
             [value]="testQuery()"
             (input)="onTestQueryInput($any($event.target).value)"
             [placeholder]="'ASSIGNMENTS.CREATE.TEST_SEARCH' | translate">
    </div>

    <!-- Test grid -->
    <div class="asg-picker__body">
      <!-- Loading skeleton -->
      <div *ngIf="testsLoading()" class="asg-picker__grid">
        <div class="asg-picker__skel" *ngFor="let _ of [1,2,3,4,5,6]"></div>
      </div>

      <!-- Erreur de chargement : jamais de données de substitution -->
      <app-error-state *ngIf="!testsLoading() && testsErrored()"
                       titleKey="ASSIGNMENTS.CREATE.ERROR_TITLE"
                       messageKey="ASSIGNMENTS.CREATE.ERROR_DESC"
                       (retry)="reloadTests()"></app-error-state>

      <div *ngIf="!testsLoading() && !testsErrored()" class="asg-picker__grid">
        <button *ngFor="let t of filteredTests()"
                class="asg-picker__card"
                type="button"
                (click)="selectTest(t)">
          <span class="asg-picker__card-mode"
                [style.color]="testModeBadge(t.testMode).color"
                [style.background]="testModeBadge(t.testMode).bg">
            <i [class]="testModeBadge(t.testMode).icon"></i>
            {{ testModeBadge(t.testMode).label | translate }}
          </span>
          <span class="asg-picker__card-title">{{ t.title }}</span>
          <span class="asg-picker__card-meta">
            <span *ngIf="t.subjectName"><i class="fa-solid fa-book"></i> {{ t.subjectName }}</span>
            <span *ngIf="t.questionsCount"><i class="fa-solid fa-circle-question"></i> {{ t.questionsCount }}</span>
            <span *ngIf="t.timeLimitMinutes"><i class="fa-regular fa-clock"></i> {{ t.timeLimitMinutes }}min</span>
          </span>
          <span class="asg-picker__card-cta">
            {{ 'ASSIGNMENTS.CREATE.SELECT_BTN' | translate }}
            <i class="fa-solid fa-arrow-right"></i>
          </span>
        </button>

        <div *ngIf="filteredTests().length === 0" class="asg-picker__empty">
          <i class="fa-solid fa-box-open"></i>
          <span>{{ 'ASSIGNMENTS.CREATE.NO_TESTS' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="asg-modal__footer">
      <button class="asg__btn asg__btn--ghost" type="button" (click)="closeCreate()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
  </ng-container>

  <!-- ── STEP 2 : configure target ─────────────────────────── -->
  <ng-container *ngIf="createStep() === 2">
    <div class="asg-modal__step-header">
      <h2 class="asg-modal__title">
        <i class="fa-solid fa-clipboard-plus"></i>
        {{ 'ASSIGNMENTS.CREATE.STEP2_TITLE' | translate }}
      </h2>
    </div>

    <div class="asg-modal__body">

      <!-- Selected test summary -->
      <div class="asg-selected-test" *ngIf="selectedTest()">
        <span class="asg-selected-test__mode"
              [style.color]="testModeBadge(selectedTest()!.testMode).color"
              [style.background]="testModeBadge(selectedTest()!.testMode).bg">
          <i [class]="testModeBadge(selectedTest()!.testMode).icon"></i>
          {{ testModeBadge(selectedTest()!.testMode).label | translate }}
        </span>
        <span class="asg-selected-test__title">{{ selectedTest()!.title }}</span>
        <span *ngIf="selectedTest()!.subjectName" class="asg-selected-test__sub">
          <i class="fa-solid fa-book"></i> {{ selectedTest()!.subjectName }}
        </span>
        <button class="asg-selected-test__change" type="button" (click)="backToStep1()">
          <i class="fa-solid fa-pen"></i>
          {{ 'ASSIGNMENTS.CREATE.CHANGE_TEST' | translate }}
        </button>
      </div>

      <!-- Target type -->
      <div class="asg-form__group">
        <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.TARGET_TYPE' | translate }} *</label>
        <div class="asg-form__radio-group">
          <label class="asg-form__radio" [class.is-checked]="createForm.targetType === 'group'">
            <input type="radio" name="create-target" value="group"
                   [checked]="createForm.targetType === 'group'"
                   (change)="onCreateTargetTypeChange('group')">
            <i class="fa-solid fa-users"></i>
            {{ 'ASSIGNMENTS.CREATE.TARGET.GROUP' | translate }}
          </label>
          <label class="asg-form__radio" [class.is-checked]="createForm.targetType === 'subject'">
            <input type="radio" name="create-target" value="subject"
                   [checked]="createForm.targetType === 'subject'"
                   (change)="onCreateTargetTypeChange('subject')">
            <i class="fa-solid fa-book"></i>
            {{ 'ASSIGNMENTS.CREATE.TARGET.SUBJECT' | translate }}
          </label>
          <label class="asg-form__radio" [class.is-checked]="createForm.targetType === 'student'">
            <input type="radio" name="create-target" value="student"
                   [checked]="createForm.targetType === 'student'"
                   (change)="onCreateTargetTypeChange('student')">
            <i class="fa-solid fa-user-graduate"></i>
            {{ 'ASSIGNMENTS.CREATE.TARGET.STUDENT' | translate }}
          </label>
        </div>
      </div>

      <!-- Target ID (dynamic) -->
      <div class="asg-form__group" *ngIf="createForm.targetType === 'group'">
        <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.GROUP_ID' | translate }} *</label>
        <input class="asg-form__input" type="number" min="1"
               [(ngModel)]="createForm.groupId"
               [placeholder]="'ASSIGNMENTS.CREATE.FORM.GROUP_ID_HINT' | translate">
      </div>
      <div class="asg-form__group" *ngIf="createForm.targetType === 'subject'">
        <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.SUBJECT_ID' | translate }} *</label>
        <input class="asg-form__input" type="number" min="1"
               [(ngModel)]="createForm.subjectId"
               [placeholder]="'ASSIGNMENTS.CREATE.FORM.SUBJECT_ID_HINT' | translate">
      </div>
      <div class="asg-form__group" *ngIf="createForm.targetType === 'student'">
        <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.STUDENT_ID' | translate }} *</label>
        <input class="asg-form__input" type="number" min="1"
               [(ngModel)]="createForm.studentId"
               [placeholder]="'ASSIGNMENTS.CREATE.FORM.STUDENT_ID_HINT' | translate">
      </div>

      <!-- Due date -->
      <div class="asg-form__group">
        <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.DUE_DATE' | translate }}</label>
        <input class="asg-form__input" type="datetime-local"
               [(ngModel)]="createForm.dueDate">
      </div>

      <!-- Instructions -->
      <div class="asg-form__group">
        <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.INSTRUCTIONS' | translate }}</label>
        <textarea class="asg-form__textarea" rows="3"
                  [(ngModel)]="createForm.instructions"
                  [placeholder]="'ASSIGNMENTS.CREATE.FORM.INSTRUCTIONS_HINT' | translate"></textarea>
      </div>

      <!-- Error -->
      <p class="asg-form__error" *ngIf="createError()">
        <i class="fa-solid fa-triangle-exclamation"></i>
        {{ createError() | translate }}
      </p>
    </div>

    <div class="asg-modal__footer">
      <button class="asg__btn asg__btn--ghost" type="button" (click)="backToStep1()">
        <i class="fa-solid fa-arrow-left"></i>
        {{ 'COMMON.BACK' | translate }}
      </button>
      <button class="asg__btn asg__btn--create" type="button"
              (click)="submitCreate()"
              [disabled]="createSaving()">
        <i class="fa-solid fa-paper-plane" *ngIf="!createSaving()"></i>
        <span class="asg-spinner" *ngIf="createSaving()"></span>
        {{ 'ASSIGNMENTS.CREATE.SUBMIT' | translate }}
      </button>
    </div>
  </ng-container>

</div>

<!-- ══════════════════════════════════════════════════════════
     EDIT MODAL
════════════════════════════════════════════════════════════ -->
<div class="asg-modal-backdrop" *ngIf="editOpen()" (click)="closeEdit()"></div>
<div class="asg-modal" role="dialog" aria-modal="true" *ngIf="editOpen()">
  <div class="asg-modal__header">
    <h2 class="asg-modal__title">
      <i class="fa-solid fa-pen-to-square"></i>
      {{ 'ASSIGNMENTS.EDIT.TITLE' | translate }}
    </h2>
    <button class="asg-modal__close" type="button" (click)="closeEdit()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="asg-modal__body">
    <!-- Test ID -->
    <div class="asg-form__group">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.TEST_ID' | translate }} *</label>
      <input class="asg-form__input" type="number" min="1"
             [(ngModel)]="editForm.testId">
    </div>

    <!-- Target type -->
    <div class="asg-form__group">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.TARGET_TYPE' | translate }} *</label>
      <div class="asg-form__radio-group">
        <label class="asg-form__radio" [class.is-checked]="editForm.targetType === 'group'">
          <input type="radio" name="edit-target" value="group"
                 [checked]="editForm.targetType === 'group'"
                 (change)="onEditTargetTypeChange('group')">
          <i class="fa-solid fa-users"></i>
          {{ 'ASSIGNMENTS.CREATE.TARGET.GROUP' | translate }}
        </label>
        <label class="asg-form__radio" [class.is-checked]="editForm.targetType === 'subject'">
          <input type="radio" name="edit-target" value="subject"
                 [checked]="editForm.targetType === 'subject'"
                 (change)="onEditTargetTypeChange('subject')">
          <i class="fa-solid fa-book"></i>
          {{ 'ASSIGNMENTS.CREATE.TARGET.SUBJECT' | translate }}
        </label>
        <label class="asg-form__radio" [class.is-checked]="editForm.targetType === 'student'">
          <input type="radio" name="edit-target" value="student"
                 [checked]="editForm.targetType === 'student'"
                 (change)="onEditTargetTypeChange('student')">
          <i class="fa-solid fa-user-graduate"></i>
          {{ 'ASSIGNMENTS.CREATE.TARGET.STUDENT' | translate }}
        </label>
      </div>
    </div>

    <!-- Target ID (dynamic) -->
    <div class="asg-form__group" *ngIf="editForm.targetType === 'group'">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.GROUP_ID' | translate }} *</label>
      <input class="asg-form__input" type="number" min="1" [(ngModel)]="editForm.groupId">
    </div>
    <div class="asg-form__group" *ngIf="editForm.targetType === 'subject'">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.SUBJECT_ID' | translate }} *</label>
      <input class="asg-form__input" type="number" min="1" [(ngModel)]="editForm.subjectId">
    </div>
    <div class="asg-form__group" *ngIf="editForm.targetType === 'student'">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.STUDENT_ID' | translate }} *</label>
      <input class="asg-form__input" type="number" min="1" [(ngModel)]="editForm.studentId">
    </div>

    <!-- Due date -->
    <div class="asg-form__group">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.DUE_DATE' | translate }}</label>
      <input class="asg-form__input" type="datetime-local" [(ngModel)]="editForm.dueDate">
    </div>

    <!-- Instructions -->
    <div class="asg-form__group">
      <label class="asg-form__label">{{ 'ASSIGNMENTS.CREATE.FORM.INSTRUCTIONS' | translate }}</label>
      <textarea class="asg-form__textarea" rows="3" [(ngModel)]="editForm.instructions"></textarea>
    </div>

    <p class="asg-form__error" *ngIf="editError()">
      <i class="fa-solid fa-triangle-exclamation"></i>
      {{ editError() | translate }}
    </p>
  </div>

  <div class="asg-modal__footer">
    <button class="asg__btn asg__btn--ghost" type="button" (click)="closeEdit()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button class="asg__btn asg__btn--create" type="button"
            (click)="submitEdit()"
            [disabled]="editSaving()">
      <i class="fa-solid fa-floppy-disk" *ngIf="!editSaving()"></i>
      <span class="asg-spinner" *ngIf="editSaving()"></span>
      {{ 'ASSIGNMENTS.EDIT.SUBMIT' | translate }}
    </button>
  </div>
</div>
